import React from 'react';
import startCase from 'lodash/startCase';
import { useTranslation } from 'common/i18n/hooks';
import { useExperimentOptions } from 'iron/apps/experiments/src/components/hooks/experiment-options';
import { useStagedExperiment } from 'iron/apps/experiments/src/components/hooks/staged-experiment';
import { InputSize } from 'common/components/input/types';
import { SelectReact } from 'common/components/select';
import { SelectTheme } from 'common/components/select/constants';
import { Section } from 'common/components/items-menu/types';
import { ChangeEvent } from 'common/components/select/types';
import { ButtonReact } from 'common/components/button';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { InputReact } from 'common/components/input';
import { ExperimentPageNewExperimentSetting } from '../_setting';
import styles from './index.module.styl';
export function CollectionMethodExposureEvents() {
  var _stagedExperiment$set2, _stagedExperiment$set3, _stagedExperiment$set4, _stagedExperiment$set5, _stagedExperiment$set6, _stagedExperiment$set7, _stagedExperiment$set8, _stagedExperiment$set9, _stagedExperiment$set10, _stagedExperiment$set11;
  const i18n = useTranslation();
  const {
    stagedExperiment,
    stageChanges
  } = useStagedExperiment();
  const {
    experimentNames,
    variantNames,
    defaultVariantName
  } = useExperimentOptions();
  const defaultApplied = React.useRef(true);
  const [addNewExperiment, setAddNewExperiment] = React.useState(false);
  const applyExperimentName = (experimentName: string) => {
    defaultApplied.current = false;
    setTimeout(() => {
      stageChanges({
        name: startCase(experimentName),
        settings: {
          exposureEventSettings: {
            experimentName
          },
          controlKey: ""
        }
      });
    });
  };
  const handleSelectExperimentName = (ev: ChangeEvent) => {
    applyExperimentName(ev.detail.item.value);
  };
  const handleEnterExperimentName = (ev: React.ChangeEvent<HTMLInputElement>) => {
    applyExperimentName(ev.target.value.trim());
  };
  const handleSelectControlKey = (ev: ChangeEvent) => {
    stageChanges({
      settings: {
        controlKey: ev.detail.item.value
      }
    });
  };
  const handleEnterControlKey = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const value = ev.target.value.trim();
    stageChanges({
      settings: {
        controlKey: value
      }
    });
  };
  const handleEnterExperimentDisplayName = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const value = ev.target.value.trim();
    stageChanges({
      name: value
    });
  };
  React.useEffect(() => {
    var _stagedExperiment$set;
    if (stagedExperiment !== null && stagedExperiment !== void 0 && (_stagedExperiment$set = stagedExperiment.settings) !== null && _stagedExperiment$set !== void 0 && (_stagedExperiment$set = _stagedExperiment$set.exposureEventSettings) !== null && _stagedExperiment$set !== void 0 && _stagedExperiment$set.experimentName && variantNames !== null && variantNames !== void 0 && variantNames.length && !defaultApplied.current) {
      defaultApplied.current = true;
      stageChanges({
        settings: {
          controlKey: defaultVariantName
        }
      });
    }
  }, [stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set2 = stagedExperiment.settings) === null || _stagedExperiment$set2 === void 0 || (_stagedExperiment$set2 = _stagedExperiment$set2.exposureEventSettings) === null || _stagedExperiment$set2 === void 0 ? void 0 : _stagedExperiment$set2.experimentName, variantNames, defaultVariantName]);
  if (!stagedExperiment) {
    return null;
  }
  const experimentOptions: Section[] = [{
    items: experimentNames.map(name => ({
      label: name,
      value: name
    }))
  }];
  const variantOptions: Section[] = [{
    items: variantNames.map(name => ({
      label: name,
      value: name
    }))
  }];
  return <>
      <ExperimentPageNewExperimentSetting label={i18n.t("experiments.new.experiment")} data-sentry-element="ExperimentPageNewExperimentSetting" data-sentry-source-file="exposure-events.tsx">
        {addNewExperiment ? <InputReact className={styles.selectExperimentInput} value={stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set3 = stagedExperiment.settings) === null || _stagedExperiment$set3 === void 0 || (_stagedExperiment$set3 = _stagedExperiment$set3.exposureEventSettings) === null || _stagedExperiment$set3 === void 0 ? void 0 : _stagedExperiment$set3.experimentName} size={InputSize.Large} placeholder={i18n.t("experiments.new.add-experiment-placeholder")} onInput={(ev: TODO) => handleEnterExperimentName(ev)} /> : <SelectReact className={styles.selectExperimentInput} selectedOption={(_stagedExperiment$set4 = stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set5 = stagedExperiment.settings) === null || _stagedExperiment$set5 === void 0 || (_stagedExperiment$set5 = _stagedExperiment$set5.exposureEventSettings) === null || _stagedExperiment$set5 === void 0 ? void 0 : _stagedExperiment$set5.experimentName) !== null && _stagedExperiment$set4 !== void 0 ? _stagedExperiment$set4 : ""} label={(stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set6 = stagedExperiment.settings) === null || _stagedExperiment$set6 === void 0 || (_stagedExperiment$set6 = _stagedExperiment$set6.exposureEventSettings) === null || _stagedExperiment$set6 === void 0 ? void 0 : _stagedExperiment$set6.experimentName) || i18n.t("experiments.new.experiment-placeholder")} theme={SelectTheme.Select} size={ButtonSize.Large} never-show-caret menuWidth={-1} onChange={(ev: TODO) => handleSelectExperimentName(ev)} sections={experimentOptions} />}

        <ButtonReact className={styles.experimentInputTypeBtn} theme={ButtonTheme.Secondary} size={ButtonSize.Small} icon={addNewExperiment ? "search" : "plus"} onClick={() => setAddNewExperiment(prev => !prev)} data-sentry-element="ButtonReact" data-sentry-source-file="exposure-events.tsx">
          {addNewExperiment ? i18n.t("experiments.new.find-experiment") : i18n.t("experiments.new.add-experiment")}
        </ButtonReact>
      </ExperimentPageNewExperimentSetting>

      {Boolean(stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set7 = stagedExperiment.settings) === null || _stagedExperiment$set7 === void 0 || (_stagedExperiment$set7 = _stagedExperiment$set7.exposureEventSettings) === null || _stagedExperiment$set7 === void 0 ? void 0 : _stagedExperiment$set7.experimentName) && <>
          <ExperimentPageNewExperimentSetting label={i18n.t("experiments.new.control")}>
            {addNewExperiment ? <InputReact className={styles.selectExperimentInput} value={stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set8 = stagedExperiment.settings) === null || _stagedExperiment$set8 === void 0 ? void 0 : _stagedExperiment$set8.controlKey} size={InputSize.Large} placeholder={i18n.t("experiments.new.add-control-placeholder")} onInput={(ev: TODO) => handleEnterControlKey(ev)} /> : <SelectReact className={styles.selectExperimentInput} selectedOption={(_stagedExperiment$set9 = stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set10 = stagedExperiment.settings) === null || _stagedExperiment$set10 === void 0 ? void 0 : _stagedExperiment$set10.controlKey) !== null && _stagedExperiment$set9 !== void 0 ? _stagedExperiment$set9 : ""} label={(stagedExperiment === null || stagedExperiment === void 0 || (_stagedExperiment$set11 = stagedExperiment.settings) === null || _stagedExperiment$set11 === void 0 ? void 0 : _stagedExperiment$set11.controlKey) || i18n.t("experiments.new.control-placeholder")} theme={SelectTheme.Select} size={ButtonSize.Large} never-show-caret menuWidth={-1} onChange={(ev: TODO) => handleSelectControlKey(ev)} sections={variantOptions} />}
          </ExperimentPageNewExperimentSetting>

          <ExperimentPageNewExperimentSetting label={i18n.t("experiments.new.experiment-display-name")} moreInfo={i18n.t("experiments.new.experiment-display-name-more-info")}>
            <InputReact className={styles.selectExperimentInput} value={stagedExperiment === null || stagedExperiment === void 0 ? void 0 : stagedExperiment.name} size={InputSize.Large} onInput={(ev: TODO) => handleEnterExperimentDisplayName(ev)} />
          </ExperimentPageNewExperimentSetting>
        </>}
    </>;
}